// extracted by mini-css-extract-plugin
export default {"navbar-sport-light":"NavBar_navbar-sport-light__oOhqI","navbar-logo":"NavBar_navbar-logo__E+T9f","navbar-text":"NavBar_navbar-text__Nqf51","app-name":"NavBar_app-name__GsmK-"};